import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory, Link } from 'react-router';
import { Header, EditSidebar, ContractHeadertext, CtrTableHd, ContractSideBar, FormModeType } from '../../Elements';
import { ListLoader, NoRecordFound } from '../../../../shared'
import AddEditSublease from '../components/AddEditSublease';
import SubLeaseRow from '../components/SubLeaseRow';
import { contrSubleaseListAc, subLeaseFnCrudAc, contrAddEditSubleaseAc } from '../actionCreators';
import { sExportContractsAc } from '../../../../shared/actionCreators';
import { SUBLEASE_CRUD, TOGGLE_VIEW_EDIT } from '../actions';
import { S_AUDITLOG_ADD_DEL_VIEW } from '../../../../shared/actions';
import { sAuditLogAc } from '../../../../shared/actionCreators';
import AddDeleteAudit from '../../../../shared/components/AddDeleteAudit';
import UpdateAuditLog from '../../../../shared/components/UpdateAuditLog';
import { getLocalStorageInfo } from '../../../../utils';
import { trackActivity } from '../../../../utils/mixpanel';
import { assetsType } from '../../../../constants';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import backArrowIcon from '../../../../shared/assets/img/back_arrow.svg';
class SubLease extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    this.props.fetchSubLeaseList();
  }

  changeMsn =(evt) =>{
    let url = '/'+assetsType[evt.asset_type]+'/'+evt.slug+'/contracts/';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  render() {
    const { subLeaseList, assetViewId, subLeaseLoader, subLeaseCrud, auditLogView, params } = this.props;
    let assetTypeNames = {
      3: 'APU',
      4: 'LG',
      5: 'PROPELLER'
    }
    return (
      <div className="contract-container">
        <Header type="brief" headingText="Lease Management" params={this.props.params} pageTitle="Subleases" changeMsn={this.changeMsn} exportContract={this.props.exportContract}/>
        <ContractSideBar application={`Sub Leases`} type="brief" params={this.props.params} />
        <div className="contract-content-blk">
          <Link to={"/" +params.type+ "/" +params.aircraft_slug+ "/contracts"} style={{color:'#bd10e0', fontSize:'16px', fontWeight:'700'}}>
            <img width="16" src={backArrowIcon} alt="Back Icon" style={{marginRight:'3px'}}/> Back to Lease Details
          </Link>
          <ContractHeadertext
            title="Subleases"
            addAudit="Revision History"
            desc='Section holds all Subleases of the Lease'
            addNew ={getLocalStorageInfo().user.permission['contracts']['subleases'].indexOf('C') != -1 ? '+ Add Sublease':''}
            toggleAddEvent={() => this.props.subLeaseFnCrud('add', {})}
            toggleAuditlog = {() => {this.props.toggleAuditlogFn('contracts', 'ctsublease', 0, null, 'add', this.props.params.contract_slug, 'contract'); trackActivity('Revision History', { page_title: 'Subleases', application_module: 'Contracts', asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,contract_slug:`${this.props.params.contract_slug}`, item_type: 'Sublease'})}}

        />
         <div className="list-container">
           {subLeaseLoader ? <ListLoader />:null}
           <div className="table-container">
             <table>
               <CtrTableHd theads={['Name', 'Details', 'Start Date', 'End Date']}/>
               <tbody>
                 {subLeaseList.map((subLease, index) => <SubLeaseRow key={index} subLease={subLease} viewSublease={() => this.props.subLeaseFnCrud('view', subLease.id)}/>)}
               </tbody>
             </table>
             {
               !subLeaseLoader && !subLeaseList.length ?
               <NoRecordFound description="Get Started by clicking '+ Add Sublease' button above" />:null
             }
           </div>
         </div>
         <EditSidebar
           title={
             subLeaseCrud.type != '' ?
             (subLeaseCrud.type == 'add') ? 'Add Sublease':
             (subLeaseCrud.type == 'edit') ? 'Edit Sublease': 'View Sublease' : ''
             }
           editSideBar={subLeaseCrud.flag}
           toggleEditSideBar={() => this.props.toggleEditBar({type: '', data: {}, flag: false})}
         >
           {
             Object.keys(subLeaseCrud.data).length && subLeaseCrud.flag ?
             <div>
               <FormModeType
                 auditLog={true}
                 auditLogMode= {()=>{this.props.toggleAuditlogFn('contracts', 'ctsublease', 1, subLeaseCrud.data.id, 'update'); trackActivity('Revision History', { page_title: 'Subleases', application_module: 'Contracts', asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,contract_slug:`${this.props.params.contract_slug}`, item_type: 'Sublease', item_id:subLeaseCrud.data.id})}}
                 type={subLeaseCrud.type}
                 changeViewMode={()=>this.props.changeViewMode(subLeaseCrud.type)}
                 editAble = {getLocalStorageInfo().user.permission['contracts']['subleases'].indexOf('U') != -1 ? true:false}
               />
               <AddEditSublease
                 type={subLeaseCrud.type}
                 subLeaseObj={subLeaseCrud.data}
                 addEditSubLease={(data, type)=>this.props.addEditSubLease(data, type, assetViewId)}
                 toggleEditSideBar={() => this.props.toggleEditBar({type: '', data: {}, flag: false})}
                 subLeaseLoader={subLeaseLoader}
               />
             </div>:null
           }
         </EditSidebar>


      <EditSidebar
          title="Revision History"
          editSideBar={auditLogView.flag}
          toggleEditSideBar={() => this.props.closeAuditSidebar({type: 'add', data: {}, flag: false})}
          >
           {
            Object.keys(auditLogView.data).length && auditLogView.flag ?
            <div>
                <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'20px',  padding: '5px 22px 5px 25px' }}>
               {
                 auditLogView.type == "add" ?
                  auditLogView.data.map((item, index) =>
                   <AddDeleteAudit auditLogView={item} key={index}/>
               ) :
               auditLogView.data.map((item, index) =>
                   <UpdateAuditLog auditLogView={item} key={index}/>
                )
               }
            </div>
            </div>
            : <NoRecordFound title="No Revision History Found"/>
           }
        </EditSidebar>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  subLeaseList: state.ContrSubLeaseReducer.subLeaseList,
  subLeaseLoader: state.ContrSubLeaseReducer.subLeaseLoader,
  subLeaseCrud: state.ContrSubLeaseReducer.subLeaseCrud,
  auditLogView: state.sharedReducers.auditLogView,
  assetViewId: state.userAssetReducer.assetViewId
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchSubLeaseList : () => dispatch(contrSubleaseListAc(ownProps.params)),
    addEditSubLease: (data, type, assetViewId) => dispatch(contrAddEditSubleaseAc(ownProps.params, data, type, assetViewId)),
    subLeaseFnCrud: (type, id) => dispatch(subLeaseFnCrudAc(ownProps.params, type,id)),
    exportContract : (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
    toggleEditBar: (data) => dispatch({
      type: SUBLEASE_CRUD,
      payload: data
    }),
    changeViewMode: (type) => dispatch({
      type: TOGGLE_VIEW_EDIT,
      payload: type
    }),
    closeAuditSidebar: (data) => dispatch({
      type: S_AUDITLOG_ADD_DEL_VIEW,
      payload: data
    }),
    toggleAuditlogFn: (application, content_type, action, objectId, type, paramValue, paramKey) => dispatch(sAuditLogAc(application, content_type, action, objectId, type, paramValue, paramKey)),
  }
}
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RoleBasedAccess(SubLease, ['contracts', 'subleases' ,'R'])));
